import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

export const CounterPill: FC<ComponentPropsWithoutRef<'span'>> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        `
          flex h-[calc(var(--spacing-4xl)/2)] items-center justify-center
          rounded-full bg-background-surface-selected p-0 font-label-semibold
          text-foreground-surface-selected
          not-legacy:min-w-3xl not-legacy:px-md not-legacy:py-0
          not-legacy:text-label-sm
        `,
        `
          legacy:h-[1.8rem] legacy:rounded-[1rem] legacy:border
          legacy:border-transparent legacy:bg-legacy-brand-light-1
          legacy:p-[0_0.9rem] legacy:text-legacy-xs legacy:font-legacy-bold
          legacy:text-white
        `,
        className
      )}
      {...props}
    />
  );
};
